import type { AccountMerit, Merit } from "../types";

export const isAccountMerit = (merit: Merit): merit is AccountMerit =>
  merit.kind === "accountMerit";
